import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../../components/primaryComponents";
import { PlusIcon } from "../../../../../assets/svgIcons";
import { RoutedModal } from "../../../../../components/common";
import { useAllIntegratedTerminals } from "./useAllIntegratedTerminals";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";
import {
  IntegratedDeviceTable,
  WebhookUrl,
} from "../../../../../components/secondaryComponents/IntegratedTerminals";
import { intergratedTerminalInfo } from "../../../../../localdata/intergratedTerminalInfo";

export const AllIntegratedTerminals = () => {
  const {
    search,
    terminals,
    metaDetails,
    isLoadingTerminals,
    storeList,
    isWebhook,
    terminalType,
    setIsWebhook,
    gotoPage,
    filterBySearch,
    filterByStoreId,
  } = useAllIntegratedTerminals();
  const navigate = useNavigate();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Market - Payment integrations"
      description="Manage terminals connections"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={` ${globalStyles.pagePaddings} ${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">
              Manage {intergratedTerminalInfo?.[terminalType]?.primaryName}
            </h4>
            <p>
              Manage and connect lumi app to{" "}
              {intergratedTerminalInfo?.[
                terminalType
              ]?.primaryName?.toLowerCase()}{" "}
              terminals to collect payment seemlessly in your store
            </p>
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total} Terminals</p>
            <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
              {search.get("terminal_type") !== "OPAY" &&
              search.get("terminal_type") !== "INTERSWITCH" ? (
                <>
                  <primaryComponents.Button
                    classNames={"btn btn--yellow"}
                    onClick={() => setIsWebhook(true)}
                  >
                    View Webhook
                  </primaryComponents.Button>
                  <primaryComponents.Button
                    classNames={"btn btn--outline"}
                    onClick={() =>
                      navigate(
                        pathConstants.APPS_INTEGRATION_TERMINALS_CONNECT +
                          `?terminal_type=${terminalType}&business_only=true`,
                      )
                    }
                  >
                    Update Connection
                  </primaryComponents.Button>
                </>
              ) : null}
              <primaryComponents.Button
                classNames={"btn btn--primary"}
                onClick={() =>
                  navigate(
                    pathConstants.APPS_INTEGRATION_TERMINALS_CONNECT +
                      `?terminal_type=${terminalType}`,
                  )
                }
              >
                <PlusIcon className="mr-1" />
                Add Terminals
              </primaryComponents.Button>
            </div>
          </div>

          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                placeholder="Search by terminal "
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") !== null ? search.get("query") : ""}
                triggerOnInput={true}
                showsearchBtn
                classNames={`${globalStyles.searchField}`}
              />
              <div className="ml-auto" style={{ width: "200px" }}>
                <primaryComponents.SelectField
                  options={[{ name: "All stores", id: null }, ...storeList]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByStoreId(value);
                  }}
                  value={
                    storeList?.find(
                      (store) => `${store?.id}` === search.get("store_id"),
                    )?.name || "Select store"
                  }
                  floatError={false}
                />
              </div>
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingTerminals}
              classNames="mt-5"
            >
              <IntegratedDeviceTable
                deviceList={terminals}
                gotoPage={gotoPage}
                metaDetails={metaDetails}
              />
            </secondaryComponents.LoaderHelper>
          </div>

          <RoutedModal
            isActive={isWebhook}
            width={700}
            headerTitle="Connect Your Webhook"
            closeModal={() => setIsWebhook(false)}
            style={{ height: "auto" }}
          >
            <WebhookUrl
              closeModal={() => setIsWebhook(false)}
              terminalType={terminalType}
            />
          </RoutedModal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
